import angular from "angular";
import { angularJsApp } from "../app";

angularJsApp.directive('uibTypeaheadDynamic', function () {
  return {
    controller: 'UibTypeaheadControllerDynamic',
    controllerAs: '$ctrl',
    require: ['ngModel', '^?ngModelOptions', 'uibTypeaheadDynamic'],
    link: function (originalScope, element, attrs, ctrls) {
      ctrls[2].init(ctrls[0], ctrls[1]);
    }
  };
}).controller('UibTypeaheadControllerDynamic',
  function ($scope, $element, $attrs, $interpolate, $controller) {
    $attrs.uibTypeahead = $interpolate($attrs.uibTypeaheadDynamic)($scope);

    angular.extend(this, $controller('UibTypeaheadController', {
      $scope: $scope,
      $element: $element,
      $attrs: $attrs
    }));
  });
